import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom"; // Importar useSearchParams
import axios from "axios";
import API_BASE_URL from "../config/config.js";
import HeaderSection from "../components/FormatoPrint/HeaderSection/HeaderSection.jsx";
import ResultadosTable from "../components/FormatoPrint/ResultadosTable/ResultadosTable.jsx";
import PosicionesTable from "../components/FormatoPrint/PosicionesTable/PosicionesTable.jsx"; // Importar el componente de posiciones
import moment from "moment";
import "moment/locale/es"; // Asegúrate de tener el idioma español cargado en moment.js
import "../components/FormatoPrint/ResultadosTable/Resultados.css";
// FTR-0028 D-31: un descanso no es lo mismo que un partido todavia sin sortear.
import { isByeMatch } from "../utils/pendingMatchLabel.js";

const FechaSection = () => {
  const { idevent, idsport, nrofecha } = useParams();
  const [matches, setMatches] = useState([]);
  const [searchParams] = useSearchParams(); // Obtener los parámetros de búsqueda (query params)
  const idtypephase = searchParams.get("fase") || "1"; // Por defecto, idtypephase es 1 (Fase de Grupos)
  const isPosiciones = searchParams.get("posiciones") === "1"; // Verificar si el parámetro posiciones está presente

  // Mapeo de deportes a colores
  const sportColors = {
    3: "#ED7D31",
    4: "#009688",
    16: "#FFC107", // Vóleibol Damas
    17: "#00BCD4", // Vóleibol Varones
    6: "#C41D0F",
    7: "#0A599E",
    5: "#8BC34A",
    42: "#BB4F94",
  };

  // Obtener el color según el deporte actual
  const headerColor = sportColors[idsport] || "#000000"; // Color por defecto si no está en el mapeo

  // Función para traer los partidos
  const getMatches = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getmatchesperiod`, {
        idevent: idevent,
        idsport: idsport,
        nro_fecha: nrofecha,
        idtypephase: idtypephase, // Añadir el filtro de fase
      });
      console.log("matches", response.data);
      let fetchedMatches = response.data;

      // Ordenar los partidos por `time_match`
      fetchedMatches = fetchedMatches.sort((a, b) => {
        const timeA = a.time_match ? moment(a.time_match, "HH:mm") : null;
        const timeB = b.time_match ? moment(b.time_match, "HH:mm") : null;
        if (!timeA || !timeB) return 0;
        return timeA.isBefore(timeB) ? -1 : 1;
      });

      setMatches(fetchedMatches);
    } catch (error) {
      console.error("Error fetching matches:", error);
    }
  };

  useEffect(() => {
    getMatches();
    setTimeout(() => {
      window.print();
    }, 1000);
  }, [idevent, idsport, nrofecha, idtypephase]); // Añadir idtypephase como dependencia

  // FTR-0028 D-18: los grupos se derivan de los propios partidos (1..10 = A..J). La lista fija de
  // A..F omitía en silencio cualquier grupo a partir del séptimo, y el Centro de Programación admite
  // hasta diez. Para un evento de seis grupos o menos el resultado es exactamente el de antes.
  const grupos = Array.from(
    new Set(
      matches
        .map((match) => Number(match.idgrupo))
        .filter((grupoId) => Number.isInteger(grupoId) && grupoId > 0)
    )
  )
    .sort((a, b) => a - b)
    .map((grupoId) => ({ grupoId, letra: String.fromCharCode(64 + grupoId) }));

  // FTR-0028 D-20/D-31: lo que no se imprime es el DESCANSO, no el partido todavía sin sortear.
  // El filtro anterior exigía los dos participantes, así que un partido del Centro materializado
  // antes del sorteo desaparecía de la hoja. Ahora sale con "Por Definir", que es lo que
  // ResultadosTable ya sabe pintar. Un descanso real (`flag_bye`) sigue fuera, igual que antes.
  const matchesPorGrupo = (grupoId) =>
    matches.filter((match) => Number(match.idgrupo) === Number(grupoId) && !isByeMatch(match));

  const getFirstDate = () => {
    const firstMatchWithDate = matches.find((match) => match.date_match);
    if (firstMatchWithDate) {
      return moment(firstMatchWithDate.date_match).format("dddd D [de] MMMM");
    }
    return "Sábado 28 de septiembre";
  };

  return (
    <div className="contenedor-principal">
      {!(Number(idsport) === 16 || Number(idsport) === 17) && (
        <HeaderSection
          title={isPosiciones ? "TABLA DE POSICIONES" : "RESULTADOS"} // Cambiar el título si es posiciones
          subtitle={
            isPosiciones
              ? "POSICIONES - FASE DE GRUPOS"
              : `RESULTADOS - ${
                  idtypephase === "2" ? "FASE ELIMINATORIA" : "FASE DE GRUPOS"
                }`
          }
          color={headerColor}
        />
      )}

      <div className="fecha-container">
        <p>
          <strong>
            Fecha {nrofecha} <br />
            {getFirstDate()}
          </strong>
        </p>
      </div>

      {isPosiciones ? (
        <PosicionesTable
          idevent={idevent}
          idsport={idsport}
          color={headerColor} // Pasar el color a la tabla de posiciones también
        />
      ) : idtypephase === "1" ? (
        grupos.map((grupo, index) => {
          const grupoMatches = matchesPorGrupo(grupo.grupoId);
          return (
            grupoMatches.length > 0 && (
              <ResultadosTable
                key={index}
                grupo={grupo}
                matches={grupoMatches}
                color={headerColor} // Pasar el color a la tabla
                idsport={idsport} // Pasar idsport para manejar periodos en voley
              />
            )
          );
        })
      ) : (
        <ResultadosTable
          grupo={{ letra: "FASE ELIMINATORIA" }}
          matches={matches.filter((match) => !isByeMatch(match))}
          color={headerColor}
          idsport={idsport}
        />
      )}
    </div>
  );
};

export default FechaSection;
